import { useState } from 'react';

export function useChecklist(guide, user) {
  const key = `wp.help.checklist.v1.${user?.uuid || 'guest'}.${guide.id}`;
  const [state, setState] = useState(() => {
    try {
      const saved = JSON.parse(window.localStorage.getItem(key) || '[]');
      const checked = Array.isArray(saved) ? [...new Set(saved.filter(i => Number.isInteger(i) && i >= 0 && i < guide.steps.length))] : [];
      return { checked, temporary: false };
    } catch { return { checked: [], temporary: true }; }
  });
  function update(checked) {
    let temporary = false;
    try { window.localStorage.setItem(key, JSON.stringify(checked)); }
    catch { temporary = true; }
    setState({ checked, temporary });
  }
  return {
    ...state,
    toggle: index => update(state.checked.includes(index) ? state.checked.filter(i => i !== index) : [...state.checked, index]),
    reset: () => update([]),
  };
}
